import React from "react";
import Calendar from "../../Calendar/Calendar";

const Calendardiv = () => {
  return (
    <div>
      <Calendar />
    </div>
  );
};

export default Calendardiv;
